import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
    {
        n: "01",
        title: "Bind",
        desc: "Your human is verified once with a zero-knowledge proof. Every agent you run inherits a chain-agnostic SUID, cryptographically bound to you.",
        chips: ["ZK PROOF", "SUID ISSUED", "NO KYC LEAK"],
    },
    {
        n: "02",
        title: "Act",
        desc: "Agents execute across protocols and chains. Authena intercepts each call — API hits, swaps, searches — and signs a timestamped receipt.",
        chips: ["SIGNED CALLS", "TIMESTAMPED", "HALLUCINATION-PROOF"],
    },
    {
        n: "03",
        title: "Prove",
        desc: "Anyone can verify what your agent actually did. Immutable logs export in one click for SOC2, GDPR and MiCA review.",
        chips: ["PUBLIC VERIFY", "1-CLICK EXPORT", "ENTERPRISE READY"],
    },
];

export default function HowItWorks() {
    return (
        <section id="how" className="scroll-mt-24 border-y border-white/5 bg-[#06080E] px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
            <div className="mx-auto max-w-7xl">
                <Reveal>
                    <Eyebrow>Protocol flow</Eyebrow>
                    <h2 className="mt-4 max-w-2xl font-display text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">
                        Three moves. Zero trust required.
                    </h2>
                </Reveal>

                <div className="relative mt-14 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-6">
                    <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-neon-cyan/25 to-transparent md:block" />
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.12} data-testid="how-step">
                            <div className="relative" data-testid={`how-step-${s.n}`}>
                                <span className="font-display text-5xl font-extrabold text-outline">{s.n}</span>
                                <h3 className="mt-5 font-display text-lg font-semibold uppercase tracking-[0.08em] text-neon-cyan">
                                    {s.title}
                                </h3>
                                <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-400">{s.desc}</p>
                                <div className="mt-5 flex flex-wrap gap-2">
                                    {s.chips.map((c) => (
                                        <span
                                            key={c}
                                            className="rounded-full border border-white/10 bg-white/[0.02] px-2.5 py-1 font-mono text-[9px] uppercase tracking-[0.18em] text-slate-400"
                                        >
                                            {c}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}